import { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import "./App.scss";
import Footer from "./components/Footer/Footer";
import Navbar from "./layout/Navigation/Navbar";
import Home from "./pages/Home/Home";
import ChooseAmount from "./pages/ChooseAmount/ChooseAmount";
import Confirm from "./pages/Confirm/Confirm";
import PurchaseResult from "./pages/PurchaseResult/PurchaseResult";
import GoogleAnalytics from "./components/GoogleAnalytics/GoogleAnalytics";
import SmartLook from "./components/SmartLook/SmartLook";
import Loading from "./components/Loading/Loading";

function App() {
    return (
        <Suspense fallback={
            <div className="suspense-loading">
                <Loading content="" />
            </div>}>
            <Switch>
                <Route path="/" exact>
                    <Navbar />
                    <Home />
                </Route>

                <Route path="/choose-amount">
                    <Navbar />
                    <ChooseAmount />
                </Route>
                <Route path="/confirm">
                    <Navbar />
                    <Confirm />
                </Route>

                <Route path="/purchase-result">
                    <PurchaseResult />
                </Route>

                <Route path="*">
                    <Redirect to="/" />
                </Route>
            </Switch>
            <Footer />
            <GoogleAnalytics />
            <SmartLook />
        </Suspense>
    );
}

export default App;
